"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var CatSchmuck32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M16 12.625c-3.988 0-7.222 3.219-7.222 7.192 0 3.974 3.234 7.192 7.222 7.192s7.223-3.219 7.223-7.192c0-3.973-3.235-7.192-7.223-7.192zm0 13.385c-3.437 0-6.222-2.772-6.222-6.192s2.786-6.192 6.222-6.192 6.223 2.772 6.223 6.192S19.437 26.01 16 26.01z" }),
    react_1.default.createElement("path", { d: "M16.758 10.897l3.398-3.564a.5.5 0 00-.043-.729l-1.9-1.58a.498.498 0 00-.319-.115h-3.8a.504.504 0 00-.32.115l-1.9 1.58a.499.499 0 00-.042.729l3.399 3.565C10.622 11.288 7 15.129 7 19.82c0 4.951 4.031 8.962 9 8.962s9-4.011 9-8.962c0-4.695-3.629-8.539-8.242-8.923zm-2.484-4.989h3.438l.726.603h-4.89l.726-.603zm4.33 1.603l-2.611 2.739-2.611-2.739h5.222zM16 27.782c-4.418 0-8-3.564-8-7.962s3.582-7.961 8-7.961 8 3.564 8 7.961c0 4.398-3.582 7.962-8 7.962z" }))); };
var StyledCatSchmuck32 = styled_components_1.default(CatSchmuck32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCatSchmuck32;
var templateObject_1;
//# sourceMappingURL=CatSchmuck32.js.map